import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import vuetify from './plugins/vuetify'
 
 
 

Vue.config.productionTip = false
 
 

 

var firebaseConfig = {
  apiKey: "AIzaSyDV_ow4UCaTpPbkolQNuKijX9Ahpg4MZpA",
  authDomain: "todoapp-b02a8.firebaseapp.com",
  projectId: "todoapp-b02a8",
  storageBucket: "todoapp-b02a8.appspot.com",
  messagingSenderId: "293241448636",
  appId: "1:293241448636:web:89ddc957c728509ef008b9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
 

 
new Vue({
  router,
  vuetify,
  
 
  
  render: h => h(App)
}).$mount('#app')
